import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { AttachedFileFragmentDoc } from '../../../../utils/graphql/fragments/__generated__/attachedFile';
export type ChangeRequestFragment = { __typename?: 'ChangeRequest', id: string, sourceId: string, sourceType: string, state: Types.ChangeRequestsStateEnumType, createdAt: string, processedAt?: string | null, initiatedBy: { __typename?: 'User', id: number, name: string }, processedBy?: { __typename?: 'User', id: number, name: string } | null, attachedFiles: Array<{ __typename?: 'AttachedFile', context: string, createdAt: string, cleanedId?: number | null, downloadUrl?: string | null, id: string, isCleaned: boolean, isStp?: boolean | null, largeUrl?: string | null, name: string, parentId?: number | null, uid: string, updatedAt: string, url?: string | null, mediumUrl?: string | null, preview?: string | null, previewPriority: number, description?: string | null }>, data: { __typename?: 'ProviderData', bankAccountHolderName?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, bankAccount?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, bankCode?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, bankName?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, bankCountry?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, payoutTransferType?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, legalName?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, vatId?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, datevKonto?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, intacctId?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, notVatPayer?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, billingAddress?: { __typename?: 'BillingAddressData', country?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, city?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, zip?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null, address?: { __typename?: 'DataItem', old?: string | null, new?: string | null } | null } | null } };

export const ChangeRequestFragmentDoc = gql`
    fragment changeRequest on ChangeRequest {
  id
  sourceId
  sourceType
  state
  createdAt
  initiatedBy {
    id
    name
  }
  processedAt
  processedBy {
    id
    name
  }
  attachedFiles {
    ...attachedFile
  }
  data {
    ... on ProviderData {
      bankAccountHolderName {
        old
        new
      }
      bankAccount {
        old
        new
      }
      bankCode {
        old
        new
      }
      bankName {
        old
        new
      }
      bankCountry {
        old
        new
      }
      payoutTransferType {
        old
        new
      }
      legalName {
        old
        new
      }
      vatId {
        old
        new
      }
      datevKonto {
        old
        new
      }
      intacctId {
        old
        new
      }
      notVatPayer {
        old
        new
      }
      billingAddress {
        country {
          old
          new
        }
        city {
          old
          new
        }
        zip {
          old
          new
        }
        address {
          old
          new
        }
      }
    }
  }
}
    ${AttachedFileFragmentDoc}`;